import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { alertError, alertSuccess } from '../../components/Toast';
import {
  fetchExternalView,
  sendExternalAction,
} from '../../core/utils/externalLinks';
import ModalBudget from '../../screens/ModalExternalBudget/ModalExternalBudget';

const ExternalBudgetContainer = () => {
  const location = useLocation();
  let history = useHistory();
  const token = location.pathname.split('/')[2];
  const [values, setValues] = useState({});
  const [client, setClient] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [service, setService] = useState([]);
  const [aeService, setAeService] = useState([]);
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [printCompany, setPrintCompany] = useState({});

  const loadData = async () => {
    const { data, error } = await fetchExternalView('budget', token);
    if (error || !data?.record) {
      history.push('/login');
      return;
    }
    const { record, client: clientRows, company, vehicles } = data;
    setValues(record);
    setService(JSON.parse(record.service) || []);
    setAeService(JSON.parse(record.ae_service) || []);
    setParts(JSON.parse(record.parts) || []);
    setClient(
      (clientRows || []).map((item) => ({ label: item.name, value: item.id }))
    );
    setVehicle(
      (vehicles || []).map((item) => ({
        label: `${item.brand} / ${item.model} / ${item.plate}`,
        value: item.id,
      }))
    );
    if (company) setPrintCompany(company);
  };

  useEffect(() => {
    loadData();
  }, [token]);

  const approve = async () => {
    setLoading(true);
    const { data, error } = await sendExternalAction('budget', token, 'approve');
    setLoading(false);

    if (!error) {
      setValues(data[0]);
      alertSuccess('Orçamento aprovado com sucesso!');
    } else {
      alertError('Erro ao aprovar orçamento!');
    }
  };

  const analyse = async () => {
    setLoading(true);
    const { data, error } = await sendExternalAction('budget', token, 'analyse');
    setLoading(false);

    if (!error) {
      setValues(data[0]);
      alertSuccess('Orçamento em análise');
    } else {
      alertError('Erro, tente mais tarde!');
    }
  };

  const inDoubt = async () => {
    setLoading(true);
    const { data, error } = await sendExternalAction('budget', token, 'doubt');
    setLoading(false);

    if (!error) {
      setValues(data[0]);
      alertSuccess('Orçamento em análise');
    } else {
      alertError('Erro, tente mais tarde!');
    }
  };

  return (
    <>
      <ModalBudget
        printCompany={printCompany}
        values={values}
        client={client}
        vehicle={vehicle}
        service={service}
        aeService={aeService}
        parts={parts}
        loading={loading}
        inDoubt={inDoubt}
        analyse={analyse}
        approve={approve}
      />
    </>
  );
};

export default ExternalBudgetContainer;
